<template>
	<div>
		<h3 class="step-title">{{ currentDesign }}</h3>

		<div class="availableValues">
			<DesignRadio
				v-for="availableValue of currentStep.availableValues"
				:key="availableValue.id"
				:availableValue="availableValue"
				:name="currentStep.id"
				:model="currentDesign"

				@update:model="newDesignHandler"
			/>

			<div class="ar-button">
				<ARBtn
					@show-ar-pop-up="$emit('show-ar-pop-up')"
				/>
			</div>
		</div>



	</div>
</template>

<script>
import useCustomizer from '@/composables/Customizer';
import DesignRadio from '@/components/Customizer/steps/DesignChanger/DesignRadio';
import { computed } from 'vue';
import ARBtn from '@/components/Customizer/ARBtn';

export default {
	name: 'DesignChanger',
	components: { ARBtn, DesignRadio },
	setup() {
		const {
			currentStep,
			objectsState,
			updateObjectsState,
		} = useCustomizer();

		const currentDesign = computed(() => {
			const currentObject = objectsState.value.find((object) => object.id === currentStep.value.target);
			return currentObject.color;
		});

		const newDesignHandler = (payload) => {
			updateObjectsState(payload);
		};

		return {
			currentStep,
			currentDesign,

			newDesignHandler,
		};

	},
};
</script>

<style lang="sass" scoped>
.availableValues
	display: flex

.step-title
	margin: 0 0 10px 0

	text-transform: capitalize

	font-weight: 600
	font-size: 18px
	line-height: 25px

	letter-spacing: -0.015em

	@media (max-width: 650px)
		font-size: 16px

.ar-button
	margin-left: auto
	@media (min-width: 650px)
		display: none

</style>
